import React, {FC, useEffect, useState} from "react";
import {CharsOrder} from "./ChartsOrder";
import ChartAbilities from "./ChartAbilities";
import BlockReport from "./BlockReport";
import {Sento, usePermissionChecker, UserLoggedIn} from "../../hooks/PermissionChecker";
import * as DashboardCRUD from "./DashboardCRUD";
import {ITotalReport} from "../../models/DashboardModel";
import { InvoiceCharts } from "./InvoiceCharts";
import SvExpiresBlock from "./SvExpiresBlock";
import { LIST_PERMISSIONS } from "../../constants/common";
import { Link, useHistory } from "react-router-dom";

const DashboardPage: FC = () => {
  const isSento = Sento();
  const user = UserLoggedIn();
  const initStore = isSento ? null : user.store_id
  const [store, setStore] = useState<any>(initStore)
  const [total, setTotal] = useState<ITotalReport>()
  const { hasPermission } = usePermissionChecker()

  const history = useHistory();
  useEffect(() => {
		document.title = 'Sento - Thống kê chung';
	})

  useEffect(() => {
    const getTotal = async () => {
      const {data} = await DashboardCRUD.getTotal({store});
      setTotal(data.data);
    }
    getTotal();

  }, [store]);

  return <>
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-12'>
         <div className="d-flex justify-content-end mt-3 mb-3 btns-group">
            {hasPermission(LIST_PERMISSIONS.CONSIGN_PRODUCTS) && (
              <Link to={'/products/consignment'} className='btn btn-warning mx-1 btn-sm' title='SP ký gửi mới'><i className='fas fa-archive'/> SP ký gửi mới</Link>
            )}
            {!isSento && hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST) && (
              <Link to={'/warehouse/receipt/import-requests'} className='btn btn-info mx-1 btn-sm' title='Nhập hàng ký gửi'><i className='fas fa-truck'/> Nhập hàng ký gửi</Link>
            )}
        </div>
        {(hasPermission(LIST_PERMISSIONS.ABILITIES) && !!(total?.pending_payment_request && total?.pending_payment_request > 0)) && (
          <div onClick={() => history.push(`/abilities/payment-request`)} className="alert alert-warning cursor-pointer" role="alert">
            Bạn có {total?.pending_payment_request} yêu cầu thanh toán đang chờ xử lý!
          </div>
        )}
        <BlockReport total={total}/>
      </div>
      <InvoiceCharts
        store={store}
        className='mb-5'
        colorBase='--bs-primary'
      />
      <div className='col-xxl-12 mt-0'>
        <SvExpiresBlock storeData={user?.store}/>
      </div>
      <div className='col-xxl-12'>
        <ChartAbilities
          store={store}
          className='mb-5'
          colorBase='--bs-primary'
        />
      </div>
      <div className='col-xxl-12'>
        <CharsOrder
          store={store}
          className='mb-5'
          colorBase='--bs-primary'
        />
      </div>
    </div>
  </>
}
export default DashboardPage;